export default "__VITE_ASSET__CHla1v$Y__"